import { IconNames } from 'src/components/icons'
import { fetchRequest } from 'src/hooks/useAPIRequest'

export interface MenuGroup {
    key: string
    name: string
    items: MenuItem[]
}

export interface MenuItem {
    key: string
    name: string
    icon: IconNames
    count: number
    warningCount: number
    warningDescription?: string
    dataLink: string
    dataLinkWarning?: string
    items: MenuItem[] | null
}

export interface ApplicationModule {
    key: string
    name: string
    icon: IconNames
    path: string
    itemGroups: MenuGroup[]
}

export interface Application {
    key: string
    name: string
    baseUrl: string
    logoUrl: string
    modules: ApplicationModule[]
}

interface ApplicationModuleResult extends Omit<ApplicationModule, 'path' | 'itemGroups'> {
    itemGroups: MenuGroup[]
}

interface ApplicationResult extends Omit<Application, 'baseUrl' | 'modules'> {
    modules: ApplicationModuleResult[]
}

const getApplications = async (): Promise<Application[]> => {
    const result = await fetchRequest<ApplicationResult[]>('/inspection/meta')

    return result.map((app) => ({
        ...app,
        baseUrl: `/${app.key.toLowerCase()}`,
        modules: app.modules.map((module) => ({
            ...module,
            icon: module.icon ?? 'faQuestion',
            path: `/${module.key.toLowerCase()}`,
            itemGroups: module.itemGroups.map((group) => ({
                ...group,
                items: group.items.map((item) => ({
                    ...item,
                    icon: item.icon ?? 'faQuestion',
                })),
            })),
        })),
    }))
}

export default getApplications
